import { isNullOrEmpty, printf, toText } from "./fable_modules/fable-library.3.7.20/String.js";

const storage = window.localStorage;

function getKey(moduleName, key_1) {
    return toText(printf("%s.%s"))(moduleName)(key_1);
}

export function setItem(moduleName, key_1, value) {
    storage.setItem(getKey(moduleName, key_1), value);
}

export function getItem(moduleName, key_1) {
    const item = storage.getItem(getKey(moduleName, key_1));
    if (isNullOrEmpty(item)) {
        return void 0;
    }
    else {
        return item;
    }
}

export function removeItem(moduleName, key_1) {
    storage.removeItem(getKey(moduleName, key_1));
}

export const clear = () => {
    storage.clear();
};

export function key(index) {
    return storage.key(index);
}

